import Cookie from "js-cookie";
// 生成 uuid
export function uuid() {
  if (typeof window !== "undefined" && typeof window.crypto !== "undefined") {
    return ("" + [1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (ch) {
      var c = Number(ch);
      return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
    });
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
      v = c == "x" ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}
/**
 * @description 初始化UUID，只需项目初始化执行一次
 * 会生成cookie里的 uuid 和 device_id
 */
export function initUUID() {
  if (typeof window !== "undefined") {
    Cookie.remove("uuid", {
      path: "/"
    });
    var isCookieUUID = Cookie.get("uuid");
    var isStorageUUID = localStorage.getItem("UUID") || localStorage.getItem("uuid");
    localStorage.removeItem("UUID");
    if (!!isCookieUUID) {
      localStorage.setItem("uuid", isCookieUUID);
      Cookie.set("device_id", isCookieUUID, {
        expires: 3650,
        domain: ".8891.com.tw"
      });
      return false;
    }
    if (!!isStorageUUID) {
      Cookie.set("uuid", isStorageUUID, {
        expires: 3650,
        domain: ".8891.com.tw"
      });
      Cookie.set("device_id", isStorageUUID, {
        expires: 3650,
        domain: ".8891.com.tw"
      });
      return false;
    }
    var newUUID = uuid();
    localStorage.setItem("uuid", newUUID);
    Cookie.set("uuid", newUUID, {
      expires: 3650,
      domain: ".8891.com.tw"
    });
    Cookie.set("device_id", newUUID, {
      expires: 3650,
      domain: ".8891.com.tw"
    });
    return newUUID;
  }
  return false;
}